/* eslint-disable camelcase */
import PropTypes from "prop-types";
import ReactAvatar from "react-avatar";
import { Image } from "common-components";

import "../../css/candidateAvatar.css";

const Avatar = ({ profile_picture_url = null, size, name }) => {
  return (
    <span className="avatar employee-profile-picture">
      <div style={{ width: `${size}px`, height: `${size}px` }}>
        {!profile_picture_url ? (
          <ReactAvatar
            name={name}
            round
            size={size}
            maxInitials={2}
            className="candidate-shortlist"
          />
        ) : (
          <Image src={profile_picture_url} circular className="image-photo" />
        )}
      </div>
    </span>
  );
};

Avatar.propTypes = {
  profile_picture_url: PropTypes.string,
  size: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default Avatar;
